// extracted by mini-css-extract-plugin
export default {"modalContainer":"Modal_modalContainer__J8roM","modalTitle":"Modal_modalTitle__Xt2G0","alertMessage":"Modal_alertMessage__z5UAz","isConfirmation":"Modal_isConfirmation__v6lc3"};